export function getFollowerAccessFromRoles(roles: any[], unionId: string) {
  // /i/roles returns all effective permissions. /i/permissions is paginated and
  // its legacy server implementation ignores the school/preset filters.
  const permissions = (roles || []).filter(role => role.name === 'TOURNAMENT_FOLLOWER')
    .reduce((all, role) => all.concat(role.permissions || []), [])
    .filter(permission => permission.preset === 'TOURNAMENT_FOLLOWER' &&
      String(permission.schoolId || permission.school?.id || '') === String(unionId) &&
      (!permission.status || permission.status === 'ACTIVE'));
  if (permissions.some(permission => !permission.tournamentId)) return {scope: 'union', tournaments: []};
  const tournaments = permissions.filter(permission => permission.tournamentId).map(permission => ({
    id: String(permission.tournamentId), name: permission.tournamentName || 'Your selected tournament'
  }));
  return {scope: tournaments.length ? 'tournament' : 'none', tournaments};
}

export const getFollowerEntryPath = (unionId: string) => '/follow?union=' + encodeURIComponent(unionId);
